import { featureItems } from '@/mocks/homeData';

export default function Features() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">为什么选择51吃瓜网</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[600px] mx-auto">
            五大核心优势，为你打造极致的吃瓜体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {featureItems.map((item, i) => (
            <div
              key={i}
              className="group relative bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6 transition-all duration-300 hover:border-primary-200 hover:bg-primary-50/30"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100/70 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}